import {useCallback, useEffect, useState} from 'react';
import {useAuth} from '../../../helpers/AuthContext';

// Each resource fails/retries independently. Hide old data immediately when the URL changes,
// and ignore late responses even when a fetch implementation does not honor AbortSignal.
export default function useCustomerRead(path, {api = true} = {}) {
  const {fetch, API_URL} = useAuth();
  const url = path ? (api ? `${API_URL}${path}` : path) : null;
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({});
  const retry = useCallback(() => setAttempt(value => value + 1), []);

  useEffect(() => {
    if (!url) return undefined;
    const controller = new AbortController();
    let active = true;
    setState({url, loading: true});
    (async () => {
      try {
        const response = await fetch(url, {method: 'GET', signal: controller.signal});
        if (!response.ok) {
          throw new Error(response.status === 404
            ? 'This customer or item is unavailable.'
            : 'Unable to load this information. Please try again.');
        }
        const data = await response.json();
        if (active) setState({url, data, loading: false});
      } catch (error) {
        if (active) setState({url, error: error.message, loading: false});
      }
    })();
    return () => {
      active = false;
      controller.abort();
    };
  }, [url, attempt, fetch]);

  return {...(state.url === url ? state : {loading: Boolean(url)}), retry};
}
